import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, Tooltip, Divider } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './style.module.css';

// 1. Main Card Component
export const SettingsCard = ({ children }) => {
  return <Box className={styles.settingsCard}>{children}</Box>;
};

// 2. Card Header Component
export const SettingsCardHeader = ({
  title,
  subtitle,
  tooltipText,
  isEditMode,
  onEdit,
  onSave,
  onCancel,
  editButtonProps = {},
  editButtonText = 'generic.edit',
  saveButtonText = 'generic.save',
  cancelButtonText = 'generic.cancel',
  alwaysEditable = false,
  isDirty = false,
}) => {
  const { t } = useTranslation();

  // New behavior: if alwaysEditable, show Save/Cancel only when isDirty
  // Old behavior: show Edit button, then Save/Cancel when in edit mode
  const showActions = alwaysEditable ? isDirty : isEditMode;
  const showEditButton = !alwaysEditable && !isEditMode && onEdit;

  return (
    <>
      <Box className={styles.cardHeader}>
        <Box className={styles.titleSection}>
          <Box className={styles.titleRow}>
            <Typography className={styles.title} variant="h6">
              {title}
            </Typography>
            {tooltipText && (
              <Tooltip title={tooltipText} placement="top" arrow>
                <InfoOutlinedIcon color="primary" />
              </Tooltip>
            )}
          </Box>
          {subtitle && <Typography className={styles.subtitle}>{subtitle}</Typography>}
        </Box>

        {showEditButton && (
          <Tooltip
            title={editButtonProps.tooltipTitle || ''}
            disableHoverListener={!editButtonProps.tooltipTitle}
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={onEdit}
                size="large"
                disabled={editButtonProps.disabled}
              >
                {t(editButtonText)}
              </Button>
            </span>
          </Tooltip>
        )}

        {showActions && (
          <Box className={styles.actionSection}>
            <Button variant="outlined" color="primary" onClick={onCancel} size="large">
              {t(cancelButtonText)}
            </Button>
            <Button variant="contained" color="primary" onClick={onSave} size="large">
              {t(saveButtonText)}
            </Button>
          </Box>
        )}
      </Box>
      <Divider className={styles.divider} />
    </>
  );
};

// 3. Card Content Component
export const SettingsCardContent = ({ children }) => {
  return <Box className={styles.cardContent}>{children}</Box>;
};
